import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import {
  Divider,
  IconButton,
  MenuItem,
  Tooltip,
  Typography,
  Button,
  Modal,
} from "@mui/material";
import Logo from "../assets/Logo.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import secureLocalStorage from "react-secure-storage";
import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch } from "react-redux";
import { updateUser } from "../actions/user";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";
import "./header.scss";

import { Link as Linked } from "react-router-dom";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { signOut } from "../Api/index";
import { SIDEBAR_COLORS as C, SIDEBAR_WIDTH, TOP_BAR_HEIGHT } from "./SideBar";

// eslint-disable-next-line react/prop-types
export default function Header({ sidebarOpen = true }) {
  const [ModalOpen, setModalOpen] = React.useState(false);

  const handleOpen = () => {
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const [anchorElUser1, setAnchorElUser1] = React.useState(null);
  const handleOpenUserMenu1 = (event) => {
    setAnchorElUser1(event.currentTarget);
  };
  const handleCloseUserMenu1 = () => {
    setAnchorElUser1(null);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    let loggingOutId;
    loggingOutId = toast.loading("Please wait we are logging you out...");
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      // Ends the shared login, so the other apps are logged out too
      signOut().catch(() => {});
      dispatch({ type: "LOGOUT" });
      navigate("/investment/login");
      toast.remove(loggingOutId);
      toast.success("You are out, see you again");
    }, 2000);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        elevation={0}
        position="fixed"
        sx={{
          px: { xs: 1.2, md: 2 },
          height: TOP_BAR_HEIGHT,
          justifyContent: "center",
          backgroundColor: C.bg,
          borderBottom: `1px solid ${C.line}`,
          boxShadow: "none",
          zIndex: 1200,
        }}
      >
        <Box
          sx={{
            ml: `${sidebarOpen ? SIDEBAR_WIDTH : 0}px`,
            // room for the show/hide menu button
            pl: 5.5,
            transition: "margin-left 0.3s ease-in-out",
            minHeight: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* Left Brand */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              minWidth: 0,
              gap: 1.2,
            }}
          >
            <Box
              sx={{
                width: 38,
                height: 38,
                borderRadius: "13px",
                display: "grid",
                placeItems: "center",
                backgroundColor: "rgba(255,255,255,0.12)",
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              <img
                width={30}
                height="auto"
                src={Logo}
                alt="src logo"
                style={{ display: "block" }}
              />
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h6"
                sx={{
                  lineHeight: 1,
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  fontWeight: 600,
                  color: "#fff",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <Linked
                  to="/investment/"
                  style={{
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  Nyankumasi-Ahenkuro Community Bank Plc.
                </Linked>
              </Typography>

              <Typography
                sx={{
                  mt: 0.35,
                  fontSize: 10.5,
                  fontWeight: 500,
                  color: C.textDim,
                  display: { xs: "none", sm: "block" },
                }}
              >
                Investment Portfolio Manager
              </Typography>
            </Box>
          </Box>

          {/* Right Actions */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.7, sm: 1 },
              flexShrink: 0,
            }}
          >
            <Tooltip title="Click to logout">
              <IconButton
                size="small"
                onClick={handleOpen}
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: "12px",
                  backgroundColor: "rgba(255,255,255,0.10)",
                  color: C.text,
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.18)",
                  },
                }}
              >
                <LogoutIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Toggle notifications panel">
              <IconButton
                size="small"
                onClick={handleOpenUserMenu1}
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: "12px",
                  backgroundColor: "rgba(255,255,255,0.10)",
                  color: C.text,
                  "&:hover": {
                    backgroundColor: "rgba(255,255,255,0.18)",
                  },
                }}
              >
                <NotificationsIcon sx={{ fontSize: 19 }} />
              </IconButton>
            </Tooltip>

            <Typography
              sx={{
                ml: { xs: 0, sm: 0.3 },
                px: 1.2,
                py: 0.5,
                borderRadius: "999px",
                backgroundColor: "rgba(255,255,255,0.10)",
                fontSize: { xs: 11, sm: 12 },
                fontWeight: 600,
                color: C.text,
                lineHeight: 1,
                whiteSpace: "nowrap",
                display: { xs: "none", sm: "block" },
              }}
            >
              NACB.
              <Box
                component="span"
                sx={{
                  color: C.accent,
                  fontStyle: "italic",
                  fontWeight: 800,
                }}
              >
                investments
              </Box>
            </Typography>
          </Box>
        </Box>

        <Menu
          sx={{ mt: "42px" }}
          id="menu-appbar"
          anchorEl={anchorElUser1}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser1)}
          onClose={handleCloseUserMenu1}
          PaperProps={{
            elevation: 0,
            sx: {
              mt: 1,
              minWidth: 230,
              borderRadius: "16px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 16px 40px rgba(15,23,42,0.13)",
              overflow: "hidden",
            },
          }}
        >
          <MenuItem
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              py: 1.2,
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 900,
                color: "#1e293b",
              }}
            >
              Notifications
            </Typography>
            <Typography
              sx={{
                mt: 0.2,
                fontSize: 11.5,
                color: "#64748b",
              }}
            >
              Recent investment updates
            </Typography>
          </MenuItem>

          <Divider />

          <MenuItem
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              py: 1.4,
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 700,
                color: "#64748b",
              }}
            >
              No messages available
            </Typography>
          </MenuItem>
        </Menu>
      </AppBar>

      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="animate__animated animate__pulse"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "88%", sm: 400 },
            maxWidth: 420,
            borderRadius: "22px",
            bgcolor: "#fff",
            border: "1px solid #e2e8f0",
            boxShadow: "0 24px 70px rgba(15,23,42,0.24)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              px: 2.4,
              py: 2,
              background: C.bg,
              color: "#fff",
            }}
          >
            <Typography
              id="modal-modal-title"
              sx={{
                fontSize: 16,
                fontWeight: 950,
                letterSpacing: "-0.01em",
              }}
            >
              Logout Confirmation
            </Typography>

            <Typography
              sx={{
                mt: 0.5,
                fontSize: 12,
                color: "rgba(255,255,255,0.75)",
              }}
            >
              Confirm before exiting your investment session.
            </Typography>
          </Box>

          <Box sx={{ px: 2.4, py: 2.2 }}>
            <Box
              sx={{
                borderRadius: "16px",
                border: "1px solid #e2e8f0",
                backgroundColor: "#f8fafc",
                px: 1.6,
                py: 1.3,
                mb: 1.8,
              }}
            >
              <Typography
                sx={{
                  fontSize: 10.5,
                  fontWeight: 900,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#94a3b8",
                }}
              >
                Logged in user
              </Typography>

              <Typography
                sx={{
                  mt: 0.4,
                  fontSize: 13.5,
                  fontWeight: 900,
                  color: "#1e293b",
                }}
              >
                {user?.results?.firstName + " " + user?.results?.lastName}
              </Typography>
            </Box>

            <Typography
              id="modal-modal-description"
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: "#475569",
                mb: 2.2,
              }}
            >
              Are you sure you want to exit?
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 1.2,
              }}
            >
              <Button
                onClick={logout}
                size="small"
                variant="contained"
                sx={{
                  flex: 1,
                  height: 36,
                  borderRadius: "12px",
                  backgroundColor: "#116149",
                  textTransform: "capitalize",
                  fontSize: 12,
                  fontWeight: 900,
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#0F523E",
                  },
                }}
                endIcon={<CheckIcon sx={{ fontSize: 17 }} />}
              >
                Yes
              </Button>

              <Button
                size="small"
                onClick={handleClose}
                variant="outlined"
                sx={{
                  flex: 1,
                  height: 36,
                  borderRadius: "12px",
                  textTransform: "capitalize",
                  fontSize: 12,
                  fontWeight: 900,
                  boxShadow: "none",
                }}
                endIcon={<CancelIcon sx={{ fontSize: 17 }} />}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
